import type { DocumentsView } from '../hooks/useDocumentsView';
import { DocumentTable } from './DocumentTable/DocumentTable';
import { DocumentTableSkeleton } from './DocumentTable/DocumentTableSkeleton';
import { DocumentGrid, type IDocumentGridProps } from './DocumentGrid/DocumentGrid';
import { DocumentGridSkeleton } from './DocumentGrid/DocumentGridSkeleton';

export interface IDocumentViewProps extends IDocumentGridProps {
  view: DocumentsView; // Which renderer — the page owns the preference, because the bar's switch reads it too.
  isLoading?: boolean; // The folder's files are still loading: show the matching skeleton instead
}

/**
 * The folder pane: the table or the card grid over one set of props, and the
 * matching skeleton while the files load. The only place the choice is made,
 * so the two renderers can't be handed different data.
 */
export function DocumentView({ view, isLoading = false, siteId, ...contents }: IDocumentViewProps) {
  if (isLoading) return view === 'grid' ? <DocumentGridSkeleton /> : <DocumentTableSkeleton />;
  // The table has no previews, so it is the one renderer that never needs the site.
  return view === 'grid' ? <DocumentGrid siteId={siteId} {...contents} /> : <DocumentTable {...contents} />;
}
